import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import { BrowserRouter as Router } from "react-router-dom";
import "./config/i18n";

const root = document.getElementById("root");
if (root) {
  ReactDOM.render(
    <Router>
      <App />
    </Router>,
    root
  );
}
